import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store";
import * as DownloadAppActions from "../../store/downloadApp/actions";
import { Link, useHistory } from "react-router-dom";
import { DialogComponent } from "../common/DialogComponent";
import ManageAppInstallations from "../Dialogs/ManageAppInstallations";
import { staticURLs } from "../../config/urls";
import { useTranslation } from "react-i18next";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

const DownloadApp: React.FunctionComponent<{ showIcon: boolean; title: string; isManageAccount: boolean }> = (props) => {
    const dispatch = useDispatch();
    const getMobileDeviceCount = () => dispatch(DownloadAppActions.actionCreators.getMobileDeviceCount());
    const partnerConfig = useSelector((state: ApplicationState) =>
        state.configurationState ? (state.configurationState.configuration ? state.configurationState.configuration.partnerConfig : null) : null
    );
    const downloadCount = useSelector((state: ApplicationState) => (state.downloadAppState ? state.downloadAppState.numberOfAuthenticatedDevices : 0));
    const isLoading = useSelector((state: ApplicationState) => (state.downloadAppState ? state.downloadAppState.isLoading : false));
    const isBusinessUser = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.userServiceDetails && state.loggedInUser.userServiceDetails.isBusinessUser
            ? state.loggedInUser.userServiceDetails.isBusinessUser
            : false
    );
    const [manageAppInstallationsIsVisible, setManageAppInstallationsIsVisible] = useState(false);
    const history = useHistory();
    const isPrimaryAccount = useSelector((state: ApplicationState) =>
        state.loggedInUser && state.loggedInUser.activeAccount && state.loggedInUser.activeAccount.accountType === "PRIMARY" ? true : false
    );

    const partnerLegalName = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.legalName
            ? state.configurationState.configuration.partnerConfig.legalName
            : ""
    );

    const checkPartnerLegalName = partnerLegalName.includes("IdentityForce");
    const isWhiteLabeledIdfPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 538
                ? true
                : false
            : false
    );
    const { t: tLang, i18n: i18nLang } = useTranslation();

    useEffect(() => {
        if (partnerConfig && partnerConfig.allowAppDownLoad === true) {
            getMobileDeviceCount();
        }
    }, []);

    useEffect(() => {
        if (downloadCount && downloadCount > 0) {
            if (history.location.hash.includes("#app-download-container")) {
                document.getElementById("app-download-container-1") && document.getElementById("app-download-container-1")!.scrollIntoView();
            }
        } else {
            if (history.location.hash.includes("#app-download-container")) {
                document.getElementById("app-download-container") && document.getElementById("app-download-container")!.scrollIntoView();
            }
        }
    }, [isLoading]);

    const closeDialog = (): any => {
        setManageAppInstallationsIsVisible(false);
    };

    const showDialog = (): any => {
        setManageAppInstallationsIsVisible(true);
    };

    return (
        <React.Fragment>
            {isPrimaryAccount &&
                partnerConfig &&
                partnerConfig.partnerProvider &&
                ((partnerConfig.partnerProvider.toLowerCase() === "idf" && partnerConfig.allowAppDownLoad === true) ||
                    (partnerConfig.partnerProvider.toLowerCase() === "ezs" && partnerConfig.allowAppDownLoad === true)) && (
                    <>
                        <div
                            className={props.showIcon === true ? "box offset-padding" : "box"}
                            id={downloadCount != null && downloadCount > 0 ? "app-download-container-1" : "app-download-container"}
                        >
                            {!isLoading ? (
                                <>
                                    <div className="box-header">
                                        <div className="box-title-container">
                                            {props.showIcon === true && (
                                                <div className="box-title-icon" aria-hidden="true">
                                                    <em className="las la-mobile"></em>
                                                </div>
                                            )}
                                            <div className="box-title-text has-actions">
                                                <h2 className="box-title heading-title">{props.title}</h2>
                                            </div>
                                        </div>

                                        {downloadCount != null && downloadCount > 0 && (
                                            <div className="box-actions">
                                                {props.isManageAccount === true ? (
                                                    <button type="button" className="btn-default btn-grey-dot" id="billing" onClick={showDialog}>
                                                    <span className="btn-text">
                                                        {tLang("dashboard.downloadAppWidget.manageDevices")}&nbsp;
                                                            <span className="btn-icon">
                                                                <RenderIcons iconName="pen" />
                                                            </span>
                                                        </span>
                                                    </button>
                                                ) : (
                                                    <Link to="/manage-account/my-account" type="button" className="btn-default btn-grey-dot" id="billing">
                                                        <span className="btn-text">
                                                            {tLang("dashboard.downloadAppWidget.manageDevices")}&nbsp;
                                                            <span className="btn-icon">
                                                                <RenderIcons iconName="pen" />
                                                            </span>
                                                        </span>
                                                    </Link>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    {downloadCount != null && downloadCount > 0 ? (
                                        <>
                                            <div className="box-content">
                                                <p>
                                                {tLang("dashboard.downloadAppWidget.deviceCountContent")} <strong>{downloadCount}</strong> {tLang("dashboard.downloadAppWidget.device")}
                                                </p>
                                            </div>
                                        </>
                                    ) : (
                                        <div className="box-content">
                                            <p>{tLang("dashboard.downloadAppWidget.message")}</p>

                                            <ul className="list-reset list-inline">
                                                <li className="margin-right-xs">
                                                    <button
                                                        type="button"
                                                        className="btn-default btn-google-play"
                                                        aria-label={tLang("dashboard.downloadAppWidget.android-aria-label")}
                                                        onClick={() => {
                                                            window.addToDataLayer({ event: "Download Android App" });
                                                            window.open(
                                                                isBusinessUser
                                                                    ? staticURLs.BusinessUserAndroidApp
                                                                    : checkPartnerLegalName || isWhiteLabeledIdfPartner
                                                                        ? staticURLs.IDFAndroidApp
                                                                        : staticURLs.EzsAndroidApp
                                                            );
                                                        }}
                                                    >
                                                        <span className="btn-app-icon">
                                                            <em className="lab la-google-play"></em>
                                                        </span>
                                                        <span className="btn-app-text">
                                                            <span className="btn-app-text-small">{tLang("dashboard.downloadAppWidget.android-text-small")}</span>
                                                            <span className="btn-app-text-big">Google Play</span>
                                                        </span>
                                                    </button>
                                                </li>
                                                <li>
                                                    <button
                                                        type="button"
                                                        className="btn-default btn-app-store"
                                                        aria-label={tLang("dashboard.downloadAppWidget.ios-aria-label")}
                                                        onClick={() => {
                                                            window.addToDataLayer({ event: "Download iOS App" });
                                                            window.open(
                                                                isBusinessUser
                                                                    ? staticURLs.BusinessUseriOSApp
                                                                    : checkPartnerLegalName || isWhiteLabeledIdfPartner
                                                                        ? staticURLs.IDFiOSAPP
                                                                        : staticURLs.EzsiOSAPP
                                                            );
                                                        }}
                                                    >
                                                        <span className="btn-app-icon">
                                                            <em className="lab la-apple"></em>
                                                        </span>
                                                        <span className="btn-app-text">
                                                            <span className="btn-app-text-small">{tLang("dashboard.downloadAppWidget.ios-text-small")}</span>
                                                            <span className="btn-app-text-big">{tLang("dashboard.downloadAppWidget.ios-text-big")}</span>
                                                        </span>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="loading"></div>
                            )}
                        </div>
                    </>
                )}

            {/* show manage app*/}
            {manageAppInstallationsIsVisible && (
                <DialogComponent dialogId="dialog-manage-app-installation" title={tLang("manageAccount.myAccount.manageAppInstallationDialog.title")} closeDialog={closeDialog}>
                    <ManageAppInstallations closeDialog={closeDialog} />
                </DialogComponent>
            )}
        </React.Fragment>
    );
};

export default DownloadApp;
